export const parseNumber = (string: string): number | null => {
  const matches = string.match(/\d+/);
  return matches ? Number.parseInt(matches[0], 10) : null;
};
